import React from 'react'
import styles from './QuothaAvatar.module.css'

type QuothaAvatarProps = {
  size?: number
  paused?: boolean
  className?: string
  alt?: string
}

const QuothaAvatar = ({
  size = 160,
  paused = false,
  className = '',
  alt = 'Quotha',
}: QuothaAvatarProps) => {
  const wrapperClass = [styles.wrapper, paused ? styles.paused : '', className].filter(Boolean).join(' ')

  return (
    <div className={wrapperClass} style={{ width: size, height: size }}>
      <img
        className={styles.img}
        src="/assets/quotha/quotha_head_l.png"
        alt={alt}
        draggable={false}
        loading="lazy"
        decoding="async"
      />
      <span className={styles.eye} aria-hidden="true" />
    </div>
  )
}

export default QuothaAvatar
